import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import _ from "lodash";
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import { transportConstants } from 'utils/constants/transport-constants'

const HelperEmployeeErrors = {
	NO_TEAM: 'no_team',
	NO_ADDRESS: 'no_address',
	NO_TRANSPORT_KIND: 'no_transport_kind',
	NO_LICENSE_PLATE: 'no_license_plate',
}

const HelperEmployee = {
	
	isValid: ( employee ) => {
		const errors = [];
		
		if( HelperSetting.isYes( settingsConstants.ENABLE_TEAMS ) ) {
			const teamGuid = EmployeeValues.values[ 'team_guid' ] ?? _.get( employee, [ 'team', 'guid' ], null );
			if ( teamGuid === null ) {
				errors.push( HelperEmployeeErrors.NO_TEAM );
			}
		}
		
		if( HelperSetting.isYes( settingsConstants.COMMUTE_FORCE_ENABLE ) ) {
			if( HelperSetting.isYes( settingsConstants.COMMUTE_ENABLE ) ) {
				const isAddressValid = _.get( employee, [ 'address', 'is_valid' ], 'no' ) === 'yes';
				if( !isAddressValid && !EmployeeValues.values[ 'address_postal_code' ] ) {
					errors.push( HelperEmployeeErrors.NO_ADDRESS );
				}
				
				const transportKind = EmployeeValues.values[ 'transport_kind' ] ?? _.get( employee, 'transport_kind', null );
				if( !transportKind && !EmployeeValues.values[ 'transport_kind' ]  ) {
					errors.push( HelperEmployeeErrors.NO_TRANSPORT_KIND );
				}
				
				// Only when transport kind is car
				if( [ transportConstants.CAR,transportConstants.CAR_ELECTRIC ].includes( transportKind ) ) {
					const licensePlate = _.get( employee, 'license_plate', null );
					if( !licensePlate && !EmployeeValues.values[ 'license_plate' ] ) {
						errors.push( HelperEmployeeErrors.NO_LICENSE_PLATE );
					}
				}
			}
		}
		
		return errors;
	}
}

export default HelperEmployee
